import { CollectionPaymentTypes, TransactionPaymentType, TransactionStatus } from "@gtpl/shared-models/common-models";
import { Column, CreateDateColumn, Entity, JoinColumn, ManyToOne, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";

@Entity('collections')
export class CollectionsEntity{
    @PrimaryGeneratedColumn("increment",{name:'id'})
    id:number;
 
  @Column({
    type:"varchar",
    nullable: true,
    name: "po_num"
  })
  poNum: string;
  
  @Column({
    type:"varchar",
    nullable: false,
    name: "inv_num"
  })
  invNum: string;

 @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "inv_amt"
  })
  invAmt: number;  
  
  // @Column({
  //   type:"decimal",precision:10,scale:2,
  //   nullable: true,
  //   name: "due_amt"
  // })
  // dueAmt: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "recieved_amt"
  })
  recievedAmt: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    default:0,
    name: "bank_charges"
  })
  bankCharges: number;

  @Column({
    type:"decimal",precision:10,scale:2,
    nullable: true,
    name: "buyer_short_payment"
  })
  buyerShortPayment: number;
  
  @Column({
    type:"date",
    nullable: true,
    name: "etd"
  })
  etd: Date;  
  
  @Column({
    type:"date",
    nullable: true,
    name: "eta"
  })
  eta: Date; 

  @Column({
    type:"date",
    nullable: true,
    name: "due_date"
  })
  dueDate: Date; 

  @Column({
    type:"date",
    nullable: true,
    name: "received_date"
  })
  recievedDate: Date; 

  @Column({
    type:"enum",
    enum:TransactionPaymentType,
    nullable: true,
    name: "transaction_type"
  })
  transactionType: TransactionPaymentType; 

  @Column({
    type:"enum",
    enum:TransactionStatus,
    nullable: true,
    name: "transaction_status"
  })
  transactionStatus: TransactionStatus; 

  @Column({
    type:"int",
    nullable: true,
    name: "so_id"
  })
 soId: number;
  @Column({
    type:"int",
    nullable: false,
    name: "buyer_id"
  })
 buyerId: number;
 @Column({
    type:"int",
    nullable: true,
    name: "payment_terms_id"
  })
 paymentTermsId: number;
 @Column({
    type:"int",
    nullable: true,
    name: "bank_id"
  })
 bankId: number;

 @Column("varchar", {
    nullable: true,
    length:255,
    name: "remarks"
  })
  remarks: string | null;

  @Column({
    type:"varchar",
    nullable: true,
    name: "scroll_no"
  })
  scrollNo: string;

  @Column({
    type:"enum",
    enum:CollectionPaymentTypes,
    nullable: true,
    name: "payment_type"
  })
  paymentType: CollectionPaymentTypes;

  @Column({
    type:"date",
    nullable: true,
    name: "scroll_date"
  })
  scrollDate: Date; 

  @Column("boolean", {
    default: true,
    name: "is_active"
  })
  isActive: boolean;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;

  @Column("varchar", {
    nullable: false,
    name: "created_user"
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: "updated_at",
    type: 'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
    nullable: true,
    name: "updated_user"
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: "version_flag"
  })
  versionFlag: number;
  
}